import FeatureFlagResource from './featureflag-resource';
import { update } from 'serializr';
import { mobx, observable, action, computed } from 'mobx';
import _ from 'lodash';

export default class FeatureFlagStore {
    @observable isLoading = true;
    featueFlags = observable.map();
    appStore;
    featureFlagResource;

    constructor(appStore) {
        this.appStore = appStore;
        this.featureFlagResource = new FeatureFlagResource();
    }

    @action.bound
    loadFeatures() {
        this.isLoading = true;
        return this.featureFlagResource
            .getFeatures(this.appStore.authStore.getAccessToken())
            .then(featureFlagModels => {
                this.updateFeatures(featureFlagModels);
                this.isLoading = false;
            })
            .catch(err => {
                // TODO add logging
                console.log('Failed to load feature flags.' + err);
                this.isLoading = false;
            });
    }

    @action
    updateFeatures(featureFlagModels) {
        featureFlagModels.forEach(newFeatureFlag => {
            if (this.featueFlags.has(newFeatureFlag.featureFlagId)) {
                const featureFlag = this.featueFlags.get(newFeatureFlag.featureFlagId);
                update(featureFlag, newFeatureFlag);
            } else {
                this.featueFlags.set(newFeatureFlag.featureFlagId, newFeatureFlag);
            }
        });
    }

    isFeatureEnabled(featureConstant) {
        return !_.isEmpty(_.find(this.featueFlags.values(), { featureName: featureConstant }));
    }
}



// WEBPACK FOOTER //
// ./src/featureflags/featureflag-store.js